package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class File(
    var id: String,
    var store: String,
    var fileName: String,
    var originalName: String,
    val size: Int,
    val extension: String,
    val checksum: String,
)

val availableExtensions = listOf(
    "png", "jpg", "jpeg", "gif",
    "xls", "xlsx", "csv",
    "doc", "docx",
    "zip", "rar", "7z",
    "pdf"
)